import {FloatingSignUp} from "components/commons";
import CalculatorInfoSection from "../CalculatorInfoSection";
import Calculator from "./Calculator";
import React from "react";

const GoalPlanningLumpsumPageContent = () => (
  <>
    <Calculator />
    <FloatingSignUp />
    <CalculatorInfoSection slug="goal-planning-lumpsum" />
  </>
);

export default GoalPlanningLumpsumPageContent;
